/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roomannouncementtitle2Inputs */

const en_roomannouncementtitle2 = /** @type {(inputs: Roomannouncementtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Announcement`)
};

const de_roomannouncementtitle2 = /** @type {(inputs: Roomannouncementtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ankündigung`)
};

/**
* | output |
* | --- |
* | "Announcement" |
*
* @param {Roomannouncementtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementtitle2 = /** @type {((inputs?: Roomannouncementtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementtitle2(inputs)
	return de_roomannouncementtitle2(inputs)
});
export { roomannouncementtitle2 as "roomAnnouncementTitle" }